import React, { useState, useEffect } from "react";
import { Player, ControlBar, PlayToggle } from "video-react";
import {
  Button,
  Col,
  Row,
  Container,
  Form,
  InputGroup,
  Dropdown,
} from "react-bootstrap";
import poster from "../../../assets/images/dummy/poster.png";
import {
  addCommentShortVideo,
  getCommentShortVideoById,
  getShorts,
} from "../../../utils/api";
// import { Carousel } from "react-responsive-carousel";
import send_img from "../../../assets/images/icons/send.png";
import { NavLink, useNavigate } from "react-router-dom";
import LikeFill from "../../../assets/images/icons/like_fill";
import LikeEmpty from "../../../assets/images/icons/like_empty";
import { addLikeInShort } from "../../../utils/api";
import Pic from "../../../assets/images/icons/user.png";
import { toast } from "react-toastify";
import { useUserContext } from "../../../utils/hooks/UserContext";
import ShortVideoComponent from "../../../Coach/components/ShortVideo";
import { deleteVideoComment } from "../../../utils/api";
import { confirmAlert } from "react-confirm-alert";
import LoginComponent from "../Login/newindex";
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import Lottie from "react-lottie";
import noDataLottie from "../../../assets/lottieFiles/noData.json";
import ShareDataComp from "./../../../Coach/components/ShareData";
import InstagramReelCarousel from "../../components/RealCrousel";

const ActivityStreamShortVideoComponent = ({ onHide, commenterId, reload }) => {
  const [VideoModalShow, setVideoModalShow] = useState(false);
  const [data, setData] = useState([]);
  const [comment, setcomment] = useState("");
  const [isLoading, setisLoading] = useState(false);
  const [loginModalShow, setLoginModalShow] = React.useState(false);
  const { user } = useUserContext();
  const navigate = useNavigate();
  const [showSocial, setShowSocial] = useState(false);
  const [showSocialId, setShowSocialId] = useState(null); // Instead of showSocial boolean

  const [video, setVideo] = useState([]);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: noDataLottie,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const getData = async () => {
    const { data } = await getShorts();
    setVideo(data?.data);
    fetchData(data?.data?.[0]?.short_video_id);
  };

  const onClickCommentevent = () => {
    if (!user) {
      // navigate('/')
      setLoginModalShow(true);
      toast.error("Please login to do this action");
      return;
    }
  };

  const onClickLike = async (id) => {
    if (!user) {
      // navigate('/')
      setLoginModalShow(true);
      toast.error("Please login to do this action");
      return;
    }

    const formdata = new FormData();
    formdata.append("short_video_id", id);
    await addLikeInShort(formdata);
    getData();
  };

  useEffect(() => {
    getData();
    const canonicalUrl = window.location.origin + window.location.pathname;
    let link = document.querySelector("link[rel='canonical']");
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonicalUrl);
  }, []);

  useEffect(() => {
    fetchData(video?.[0]?.short_video_id);
  }, []);

  const fetchData = async (id) => {
    try {
      const response = await getCommentShortVideoById(id);
      setData(response?.data?.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const onChange = (e) => {
    const data = video?.find((_, index) => index === e);
    fetchData(data?.short_video_id);
  };

  const onClickComment = async (id) => {
    try {
      const formdata = new FormData();
      formdata.append("short_video_id", id);
      formdata.append("comments", comment);

      const res = await addCommentShortVideo(formdata);
      if (!res?.data?.status) {
        toast.error(res.data?.message);
        return;
      }
      setcomment("");
      toast.success("New comment added.");
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message);
    } finally {
      fetchData(id);
    }
  };

  const handleDeleteClick = (id, videoId) => {
    confirmAlert({
      title: "Confirm Deletion",
      message: "Are you sure you want to delete this Comment?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            try {
              await deleteVideoComment(id);
              toast.success("Deleted successfully!!");
              fetchData(videoId);
            } catch (error) {
              console.error("Error deleting item", error);
            }
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };
  const displaySocialIcon = (id) => {
    setShowSocial(!showSocial);
    setShowSocialId(id);
    if (showSocial === false) {
      navigator.clipboard
        .writeText(`qoach.io/single-short/` + id)
        .then(() => {
          toast.success("Link Copied to Clipboard!");
        })
        .catch((err) => {
          console.error("Unable to copy text to clipboard", err);
        });
    }
  };
  return (
    <div className="max-w-[760px] mx-auto">
      <InstagramReelCarousel />
      <LoginComponent
        show={loginModalShow}
        onHide={() => setLoginModalShow(false)}
      />
    </div>
  );
};

export default ActivityStreamShortVideoComponent;
